<template>
  <div class="q-pa-sm">
    <!-- <div>时间视图<span>></span><span>人员视图</span></div>
    <el-divider class="in"></el-divider> -->
    <div style="font-weight: 500; font-size: 15px; color: #606266 ;background-color:#fff;line-height: 50px;" class="navigation">
     <span @click="ploview">任务视图</span> | 人员视图
    </div>

    <gantt-elastic v-if="showTasks" :options="options" :tasks="tasks" style="margin-top:30px">
    </gantt-elastic>
  </div>
</template>

<script>
import GanttElastic from "gantt-elastic";
import GanttHeader from "gantt-elastic-header";
import dayjs from "dayjs";
import { gettimeuser } from "../../api/view";
import {getstatuss} from "../../api/setting";

// just helper to get current dates
function getDate(hours) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();
  const timeStamp = new Date(
    currentYear,
    currentMonth,
    currentDay,
    0,
    0,
    0
  ).getTime();
  return new Date(timeStamp + hours * 60 * 60 * 1000).getTime();
}
let that;
let tasks = [
  {
    id: 1,
    label: "Make some noise",
    start: getDate(-24 * 5),
    duration: 4 * 24 * 60 * 60 * 1000,
    percent: 85,
    type: "milestone",
    collapsed: true,
  },
  {
    id: 2,
    label: "With great power comes great responsibility",
    start: getDate(-24 * 4),
    duration: 4 * 24 * 60 * 60 * 1000,
    percent: 50,
    type: "milestone",
    collapsed: true,
    style: {
      base: {
        fill: "#1EBC61",
        stroke: "#0EAC51",
      },
    },
  },
];
let options = {
  locale: {
    weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    months: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ],
  },
  taskMapping: {
    progress: "percent",
  },
  maxRows: 100,
  maxHeight: 500,
  title: {
    label: "Your project title as html (link or whatever...)",
    html: false,
  },
  row: {
    height: 24,
  },
  calendar: {
    hour: {
      display: false,
    },
  },
  chart: {
    progress: {
      bar: false,
    },
    expander: {
      display: true,
    },
  },
  taskList: {
    expander: {
      straight: false,
    },
    columns: [
      {
        id: 1,
        label: "人员",
        value: "user_name",
        align: "center",
        width: 150,
        expander: true,
        html: true,
        // events: {
        //   click({ data, column }) {
        //     that.handleEdit(data.id)
        //   }
        // }
      },
      {
        id: 2,
        label: "任务",
        value: "label",
        align: "center",
        width: 100,
        html: true,
      },
      {
        id: 3,
        label: "状态",
        value: "Status",
        align: "center",
        width: 68,
      },
      {
        id: 4,
        label: "开始",
        value: (task) => dayjs(task.start).format("YYYY-MM-DD"),
        width: 120,
      },
      {
        id: 5,
        label: "结束",
        value: (task) => dayjs(task.end).format("YYYY-MM-DD"),
        width: 120,
      },
    ],
  },
};
//进行中
let doingStyle = {
  base: {
    fill: "",
    stroke: "",
  },
};
//阻塞
let warnStyle = {
  base: {
    fill: "",
    stroke: "",
  },
};
//已完成
let finishStyle = {
  base: {
    fill: "",
    stroke: "",
  },
};
//未开始
let cancelStyle = {
  base: {
    fill: "",
    stroke: "",
  },
};

export default {
  data() {
    return {
      doingStyle,
      finishStyle,
      warnStyle,
      cancelStyle,
      tasks,
      options,
      showTasks: false,
    };
  },
  components: {
    GanttElastic,
    GanttHeader,
  },
  //
  methods: {
    ploview() {
      this.$router.push({
        path: "/work/index",
      });
    },
    getData() {
      let params = {
        token: localStorage.getItem("token"),
      };
      gettimeuser(params).then((res) => {
        if (res.errno === 0) {
          var temp1 = res.data;
          this.tasks = [];
          var sum =0
          var username=''
          for (var j in temp1) {
            var temp = temp1[j]
            if (temp != "") {
              for (var i in temp) {
                temp[i].start_time = new Date(
                  temp[i].start_time.replace(/-/g, "/")
                );
                temp[i].end_time = new Date(
                  temp[i].end_time.replace(/-/g, "/")
                );
                sum+=1
                var obj = {
                  // project_name: temp1[j].project_name,
                  id: sum,
                  label: temp[i].name,
                  // user_name: temp[i].user_name,
                  start: new Date(temp[i].start_time).getTime(),
                  end: new Date(temp[i].end_time).getTime(),
                  Status: temp[i].status,
                  duration:
                    new Date(temp[i].end_time).getTime() -
                    new Date(temp[i].start_time),
                  type: "milestone",
                  percent: 100,
                };
                
                if (i==0) {
                  obj.user_name=temp[i].user_name+"("+temp.length+")"
                }
                // if (temp[i].user_name==temp[i+1].user_name) {

                // }
              if (temp[i].status === 1) {
                  obj.style = cancelStyle;
                  obj.Status = '未开始';
                  this.tasks.push(obj);
                } else if (temp[i].status === 2) {
                  obj.style = doingStyle;
                  obj.Status = "进行中";
                  this.tasks.push(obj);
                } else if(temp[i].status === 3) {
                  obj.style = finishStyle;
                  obj.Status = "已完成";
                  this.tasks.push(obj);
                }else{
                  obj.style = warnStyle;
                  obj.Status = "阻塞";
                  this.tasks.push(obj);
                }
              }
            }
            if (this.tasks.length > 0) {
              this.showTasks = true;
            }
          }
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
     //状态颜色
    getstatu() {
      let params = {
        token: localStorage.getItem("token"),
        page: this.currentPage3,
      };
      getstatuss(params).then((res) => {
        if (res.errno === 0) {
          this.allstatu = res.data.data;
          for(var i in this.allstatu){
            if (this.allstatu[i].id===4) {
              this.warnStyle.base.fill=this.allstatu[i].color
              this.warnStyle.base.stroke=this.allstatu[i].color
            }else if(this.allstatu[i].id===3){
              this.finishStyle.base.fill=this.allstatu[i].color
              this.finishStyle.base.stroke=this.allstatu[i].color
            }else if(this.allstatu[i].id===2){
              this.doingStyle.base.fill=this.allstatu[i].color
              this.doingStyle.base.stroke=this.allstatu[i].color
            }else{
              this.cancelStyle.base.fill=this.allstatu[i].color
              this.cancelStyle.base.stroke=this.allstatu[i].color
            }
          }

        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.errno);
        }
      });
    },
  },
  mounted() {
    this.getstatu()
    this.getData();
  },
};
</script>
<style  scoped>
/* .q-pa-sm >>> .in {
  margin: 10px 0;
} */
/* .q-pa-sm{
  padding: 10px;
} */
/* .q-pa-sm >>> .in_2 {
  margin: 15px 0;
} */
  .navigation span {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/work/pleview.vue